import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0d712582"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "userEdit"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_tree_select = _resolveComponent("el-tree-select");
  const _component_Upload = _resolveComponent("Upload");
  const _component_el_form = _resolveComponent("el-form");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives((_openBlock(), _createBlock(_component_el_form, {
    model: _ctx.admins,
    "label-width": "80px",
    "element-loading-text": _ctx.loading_text
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form_item, {
      label: "用户名"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: _ctx.admins.username,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.admins.username = $event),
        placeholder: "用户名必填",
        disabled: $props.action == 'edit_oneself' ? true : false
      }, null, 8, ["modelValue", "disabled"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "手机号"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: _ctx.admins.mobile,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.admins.mobile = $event),
        placeholder: "手机号必填"
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "邮箱"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: _ctx.admins.email,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.admins.email = $event),
        placeholder: "邮箱必填",
        type: "text",
        autocomplete: "new-password"
      }, null, 8, ["modelValue"])]),
      _: 1
    }), ($props.action != 'edit_oneself' ? false : true) ? (_openBlock(), _createBlock(_component_el_form_item, {
      key: 0,
      label: "旧密码"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: _ctx.admins.password_old,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.admins.password_old = $event),
        type: "text",
        autocomplete: "new-password",
        placeholder: "不修改密码可留空",
        class: "no-autofill-pwd"
      }, null, 8, ["modelValue"])]),
      _: 1
    })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
      label: "密码"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: _ctx.admins.password,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _ctx.admins.password = $event),
        type: "password",
        autocomplete: "new-password",
        "auto-complete": "new-password",
        placeholder: $props.action == 'add' ? '密码必须填写' : '不修改密码可留空',
        "show-password": ""
      }, null, 8, ["modelValue", "placeholder"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "确认密码"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: _ctx.admins.password_confirm,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _ctx.admins.password_confirm = $event),
        type: "password",
        autocomplete: "new-password",
        placeholder: $props.action == 'add' ? '确认密码必须填写' : '不修改密码可留空',
        "show-password": ""
      }, null, 8, ["modelValue", "placeholder"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "角色分配"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_tree_select, {
        placeholder: "选择角色",
        modelValue: _ctx.admins.role,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _ctx.admins.role = $event),
        data: _ctx.roleData,
        "check-strictly": true,
        "default-expand-all": true,
        props: {
          label: 'role_name',
          value: 'id'
        },
        multiple: "",
        filterable: ""
      }, null, 8, ["modelValue", "data"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "所属部门"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_tree_select, {
        class: "inputW180",
        placeholder: "选择所属部门",
        modelValue: _ctx.admins.department,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _ctx.admins.department = $event),
        disabled: $props.action == 'edit_oneself' ? true : false,
        data: $props.departmentData,
        props: {
          label: 'department_name',
          value: 'department_id'
        },
        "check-strictly": true,
        "default-expand-all": true,
        filterable: ""
      }, null, 8, ["modelValue", "disabled", "data"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "所属机构"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_tree_select, {
        class: "inputW180",
        placeholder: "选择所属机构",
        modelValue: _ctx.admins.org_id,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _ctx.admins.org_id = $event),
        disabled: $props.action == 'edit_oneself' ? true : false,
        data: _ctx.orgData,
        "node-key": "org_id",
        props: {
          label: 'org_name',
          value: 'org_id'
        },
        "default-expand-all": true,
        multiple: ""
      }, null, 8, ["modelValue", "disabled", "data"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "所属门店"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_tree_select, {
        class: "inputW180",
        placeholder: "选择门店",
        modelValue: _ctx.admins.store_id,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _ctx.admins.store_id = $event),
        data: _ctx.storeData,
        "node-key": "store_id",
        props: {
          label: 'store_name'
        },
        "default-expand-all": true,
        multiple: ""
      }, null, 8, ["modelValue", "data"])]),
      _: 1
    }), _withDirectives((_openBlock(), _createBlock(_component_el_form_item, {
      label: "上传头像",
      "element-loading-text": _ctx.uploading_loading_text
    }, {
      default: _withCtx(() => [_createVNode(_component_Upload, {
        ref: "Upload",
        onGetUploadFile: $options.getUploadFile,
        limit: 1,
        icon: 'upload',
        uploadSaveLocal: false,
        isShow: true,
        filesData: _ctx.admins.avatarFileList,
        isButton: false,
        file_type: 'images',
        uploadTitle: '上传头像',
        showImgList: true,
        multiple: false,
        isProgress: false
      }, null, 8, ["onGetUploadFile", "filesData"])]),
      _: 1
    }, 8, ["element-loading-text"])), [[_directive_loading, _ctx.uploading_loading]])]),
    _: 1
  }, 8, ["model", "element-loading-text"])), [[_directive_loading, _ctx.loading]])]);
}